module.exports = __webpack_public_path__ + "static/media/seth_reward.0cebdb3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bot_icons/seth_reward.png
// module id = 117
// module chunks = 0